import { createEndpoint } from "config/apiEndpoints";
import { PostData } from "hooks/api/useApiService";
import React from "react";
import { useHistory } from "react-router-dom";
import useToasterStore from "store/SnackBar/useToasterStore";
import { generalStore } from "store/generalStore";
import { getUserType } from "store/userType";
import { deleteFromStorage } from "utils/storage";

const useProfileApi = () => {
  const openToaster = useToasterStore((state) => state.openToaster);
  const setDeleteModalOpen = generalStore((state) => state.setDeleteModalOpen);
  const setSelectedProject = generalStore((state) => state.setSelectedProject);
  const setLogoutLoader = generalStore((state) => state.setLogoutLoader);
  const setUserType = getUserType((state) => state.setUserType);
  const setUserData = getUserType((state) => state.setUserData);
  const setUserRole = generalStore((state) => state.setUserRole);

  const history = useHistory();

  const goToOtherPage = (route) => {
    history.push(route);
  };

  const statusAction = {
    onSuccess: (data) => {
      if (data.data.statusCode == 200) {
        setDeleteModalOpen(false);
        openToaster("success", "Status Updated");
      }
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.data?.GeneralError[0];
      openToaster(
        "error",
        errorMessage || "something went wrong, Try again later!!!"
      );
    },
  };

  const { mutate, isLoading } = PostData(
    createEndpoint("salePersonStatus"),
    "post",
    statusAction
  );

  const logOutAction = {
    onSuccess: (data) => {
      if (data.data.statusCode == 200) {
        setLogoutLoader(false);
        sessionStorage.clear();
        setSelectedProject(null);
        goToOtherPage("/login");
        deleteFromStorage("user_data");
        deleteFromStorage("searchParams");
        // deleteFromStorage("generalStore")
        setUserType(null);
        setUserData(null);
        setUserRole([]);
        // openToaster("success", "User Logedout");
      }
    },
    onError: (error) => {
      setLogoutLoader(false);
      const errorMessage = error?.response?.data?.data?.GeneralError[0];
      openToaster(
        "error",
        errorMessage || "something went wrong, Try again later!!!"
      );
    },
  };

  const { mutate: mutateLogOut, isLoading: isLogOutLoading } = PostData(
    createEndpoint("logOut"),
    "post",
    logOutAction
  );

  return { mutate, isLoading, setDeleteModalOpen, mutateLogOut };
};

export default useProfileApi;
